import { LeftOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { useNavigationContext } from '@/hooks/use-navigation-context';
import { useProgressRouter } from '@/hooks/use-progress-router';

interface SettingsBackNavigationProps {
  isCollapsed: boolean;
}

export function SettingsBackNavigation({
  isCollapsed,
}: SettingsBackNavigationProps) {
  const router = useProgressRouter();
  const { t } = useTranslation();
  const { getContext } = useNavigationContext({
    contextType: 'settings',
    ttl: 24 * 60 * 60 * 1000,
  });

  const context = getContext();
  const backUrl = context?.previousUrl ?? '/';
  const backLabel =
    context?.previousLabel ?? t('navigation.dashboard', 'Dashboard');

  const fullLabel = t('settings.backTo', { context: backLabel });

  const handleClick = () => {
    router.push(backUrl);
  };

  if (isCollapsed) {
    return (
      <div className="flex justify-center px-2 pb-3">
        <Tooltip title={fullLabel} placement="right">
          <button
            onClick={handleClick}
            className="inline-flex cursor-pointer items-center justify-center rounded p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 dark:hover:text-white"
          >
            <LeftOutlined />
          </button>
        </Tooltip>
      </div>
    );
  }

  return (
    <div className="px-3 pb-3">
      <button
        onClick={handleClick}
        className="flex w-full cursor-pointer items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
      >
        <LeftOutlined className="text-xs" />
        <span className="truncate">{fullLabel}</span>
      </button>
    </div>
  );
}
